module.exports = __webpack_public_path__ + "img/add-option.b731afad.svg";